 export const makeSendReActivationEmailDTO = (domainName) => ({
    domainName
  });
